{
    "Action.AddComment": "Add comment",
    "Action.Close": "Close",
    "Action.CloseAll": "Close all",
    "Action.ClosePanel": "Close panel",
    "Action.CloseTab": "Close tab",
    "Action.DeleteComment": "Delete comment",
    "Action.DeleteFilling": "Delete filling",
    "Action.DuplicateFilling": "Duplicate filling",
    "Action.EditComment": "Edit comment",
    "Action.EditFilling": "Edit filling",
    "Action.ExpandTitle": "Expand {{title}}",
    "Action.Generate": "Generate",
    "Action.GenerateChecklist": "Generate checklist",
    "Action.GenerateTemplates": "Generate templates",
    "Action.GenerateToWord": "<small-1>Generate to<\/small-1> Word",
    "Action.NameFilling": "Give the filling a name",
    "Action.NewFilling": "New filling",
    "Action.OpenAll": "Open all",
    "Action.OpenFilling": "Open filling",
    "Action.OpenInDib": "Open in dib",
    "Action.OpenMenu": "Open menu",
    "Action.Reset": "Reset",
    "Action.ResetFields": "Reset fields",
    "Action.Save": "Save",
    "Action.SendToDflow": "<small-1>Send to<\/small-1> dflow",
    "Action.WriteAComment": "Make a comment",
    "Dashboard.pin": "Pin content",
    "Dashboard.pinToTop": "Pin to top",
    "Dashboard.removeFavorite.title": "Remove from favorites",
    "Dashboard.removeFromTop": "Remove from top",
    "Dashboard.unpin": "Remove pinned content",
    "Dashboard.unpin.confirm.title": "Remove pinned content?",
    "DocumentGenerator.Alternative": "Alternative",
    "DocumentGenerator.ChooseAlternative": "Choose an alternative",
    "DocumentGenerator.OptionalContent": "Optional content",
    "Error.404Description": "The page you requested is not found",
    "Error.FetchFillings": "Failed to retrieve fillings",
    "Error.NoFillingAccess": "You don't have access to this filling",
    "Error.NotFound": "Not found",
    "Error.SomethingWentWrong": "Something went wrong",
    "Error.TryReloadingOrContactUs": "Please try reloading the page, and <span-1><a-1>let us know<\/a-1> if the problem persists.<\/span-1>",
    "Error.UnknownArtifact": "422 Content cannot be displayed",
    "Info.ChooseADocumentToTheLeft": "Select a document from the left",
    "Info.DataToDuplicate": "Data to be duplicated",
    "Info.FillingWithoutName": "Filling without name",
    "Info.GenerationNotAvailableForDemoUsers": "Sorry, as a demo user you are not able to generate documents",
    "Info.IncludeInGeneration": "Include in generating job",
    "Info.MergeDocuments": "Merge selected documents into a single pdf.",
    "Info.NoAvailableDocuments": "No available documents",
    "Info.NoHits": "No hits",
    "Info.RemoveFromGeneration": "Remove from generating job",
    "Label.ConfirmAction": "Confirm selection",
    "Label.DIBStandardTemplate": "Standard design template",
    "Label.DuplicateName": "Duplicate name",
    "Label.MarkAllAsStatus": "Select the whole category as {{status}}",
    "Label.ShowLess": "Show less",
    "Label.ShowMore": "Show more",
    "Navigation.Lookup": "Lookup",
    "Phrase.AsEmailAttachment": "Attachment in e-mail",
    "Phrase.AvailableOnDib": "Available on dib",
    "Phrase.ChooseStyleTemplate": "Select design template",
    "Phrase.ChooseStyleTemplatePrompt": "Select a template",
    "Phrase.DeliveredAs": "Delivered as",
    "Phrase.DownloadFile": "Download {{file}}",
    "Phrase.DuplicateOfTitle": "Copy of {{fillingTitle}}",
    "Phrase.FieldsInDocumentGenerator": "Fields in Document Generator",
    "Phrase.InAWordDocument": "In one single Word document",
    "Phrase.IncludeInstructions": "Include guidance",
    "Phrase.LastEdited": "Last changed",
    "Phrase.LoadingModal": "Loading...",
    "Phrase.NoAccess": "No access",
    "Phrase.NoPreviousFillings": "No previous fillings",
    "Phrase.NoResultsOn": "No results on",
    "Phrase.NoSearchResults": "No results",
    "Phrase.NoTemplatesChosen": "No templates selected",
    "Phrase.RemoveFilters": "Clear filters",
    "Phrase.SearchFilling": "Search form filling",
    "Phrase.SendToDflow": "Send to dflow",
    "Phrase.ShowMore": "Show more",
    "Phrase.SorryYouDoNotHaveAccessToContent": "<strong-1>Sorry<\/strong-1>, You do not have access to this content",
    "Prompt.WouldYouLikeToDeleteFilling": "Do you want to delete <strong-1>{{fillingTitle}}<\/strong-1>?",
    "Status.Deviation": "Deviation",
    "Status.NA": "Not applicable",
    "Status.Ok": "OK",
    "Status.Todo": "To do",
    "Status.WithComment": "With comment",
    "Title.LabelOfContents": "Table of contents",
    "Title.RelatedContent": "Related",
    "Title.TemplatesWithCount": "Templates ({{selectedDocsLength}})",
    "Type.AuditTemplate": "Audit Template",
    "Type.ChartOfAccounts": "Chart of Accounts",
    "Type.ChecklistTemplates": "Checklist \/ Templates",
    "Type.Decision": "Decision",
    "Type.Directive": "Directive",
    "Type.Function": "Function",
    "Type.Handbook": "Handbook",
    "Type.JuridiskVejledning": "Juridisk Vejledning",
    "Type.Law": "Law",
    "Type.LegalCommentary": "Legal Commentary",
    "Type.Literature": "Literature",
    "Type.Nature": "Nature",
    "Type.News": "News",
    "Type.PortalReference": "Portal",
    "Type.PortalSources": "Portal",
    "Type.PortalTools": "Portal",
    "Type.Praktika": "Praktika",
    "Type.PreparatoryWorks": "Preparatory Works",
    "Type.Q&A": "Q&A",
    "Type.Regulation": "Regulation",
    "Type.SkatteABC": "Tax-ABC",
    "Type.Spreadsheet": "Spreadsheet",
    "Type.Standard": "Standard",
    "Type.Statement": "Statement",
    "Type.TaxTreaty": "Tax Treaty",
    "Type.Template": "Template",
    "Type.Topic": "Topic",
    "Type.Unknown": "Other",
    "Warn.DataToDuplicateNotChosen": "No data selected for duplication",
    "Warning.AboutToMarkAllChecklistItems": "You are about to select all checklist items in this category as <strong>{{status}}<\/strong>. Are you sure?",
    "Widget.audit.process.title": "Audit - Templates and Checklists",
    "Widget.content.description": "Content in dib I have visited",
    "Widget.content.none": "Nothing here... Content will appear as soon as you open something",
    "Widget.content.title": "Last visited",
    "Widget.favourites.title": "My favourites",
    "Widget.fillings.description": "Templates and checklists I am working on",
    "Widget.fillings.none": "Nothing here yet… Start filling out checklists and templates, and things will show up here.",
    "Widget.fillings.title": "Fillings",
    "Widget.internal.portal.allAreas": "All areas",
    "Widget.internal.portal.content": "Content",
    "Widget.internal.portal.history": "History",
    "Widget.internal.portal.history.none": "Content you open will appear here.",
    "Widget.internal.portal.myWork": "My Work",
    "Widget.internal.portal.myWork.none": "Templates and checklists you are working on will appear here",
    "Widget.internal.portal.pinned": "Pinned",
    "Widget.internal.portal.title": "Portals",
    "Widget.internal.templates.title": "Latest templates",
    "Widget.last.threads.none": "Your chats and searches will appear here",
    "Widget.last.threads.title": "Latest threads",
    "Widget.latest.news.title": "News",
    "Widget.threads.description": "Latest chats\/threads with KAI",
    "Widget.threads.none": "Nothing here... When you start searching\/chatting, things will appear here",
    "Widget.threads.title": "Conversations",
    "Word.Abort": "Cancel",
    "Word.Checklist": "Checklist",
    "Word.Close": "Close",
    "Word.Comments": "Comments",
    "Word.Confirm": "Confirm",
    "Word.Content": "Content",
    "Word.Created": "Created",
    "Word.DocumentType": "Document type",
    "Word.Duplicate": "Duplicate",
    "Word.Edit": "Change",
    "Word.Email": "E-mail",
    "Word.Error": "Error",
    "Word.Filling": "Filling",
    "Word.Footnote": "Footnote",
    "Word.Generate": "Generate",
    "Word.Info": "Info",
    "Word.Landscape": "Landscape",
    "Word.Less": "Less",
    "Word.More": "More",
    "Word.Name": "Name",
    "Word.New": "New",
    "Word.Open": "Open",
    "Word.PaperOrientation": "Orientation",
    "Word.Portrait": "Portrait",
    "Word.Remove": "Remove",
    "Word.Sources": "Sources",
    "Word.Status": "Status",
    "Word.StyleTemplate": "Design template",
    "Word.Template": "Template",
    "Word.Templates": "Templates",
    "Word.TheSearchText": "The phrase",
    "Word.Untitled": "Untitled",
    "Word.ZipFile": "ZIP file",
    "Word.create": "Create",
    "action.seeLess": "Show less",
    "action.seeMore": "Show more",
    "alert.MergeConfirmBody": "By ticking the \"PDF merging\" box, all selected documents will be merged into one PDF document. They will not be editable in Dflow.",
    "alert.MergeConfirmTitle": "PDF Merging",
    "animation.part.0": "Ask",
    "animation.part.1": "KAI",
    "animation.part.2": "about",
    "animation.suggestion.1": "payroll and HR",
    "animation.suggestion.2": "accounting and VAT",
    "animation.suggestion.3": "content in dib",
    "app.title": "KAI",
    "artifact.emailDraft.copied": "Copied!",
    "artifact.emailDraft.copyEmail": "Copy email",
    "artifact.emailDraft.empty": "Empty email draft",
    "artifact.emailDraft.openInClient": "Open in email client",
    "artifact.emailDraft.subjectLabel": "Subject",
    "artifact.emailDraft.titleFallback": "Email draft",
    "artifact.emailDraft.tooLongWarning": "The email is too long to send directly via the email client. Use the copy button to copy the content and paste it manually.",
    "artifact.generic.titleFallback": "Artifact",
    "artifact.pending.titleFallback": "Draft",
    "artifact.searchResults.noResults": "No results for \"{{query}}\"",
    "artifact.searchResults.resultsFor": "Results for \"{{query}}\"",
    "artifact.searchResults.showFewer": "Show less",
    "artifact.searchResults.showMore": "Show {{count}} more results",
    "artifact.searchResults.titleFallback": "Search results",
    "assistant.answerHeading": "Reply from KAI",
    "brand.name": "DIB",
    "callout.suggestplus.common.confirm": "Ask again with KAI+",
    "callout.suggestplus.common.text": "Do you want to perform a deeper analysis with a slightly longer waiting time?",
    "callout.suggestplus.common.title": "KAI is unable to provide a good enough answer",
    "chat.ephemeral_search.nudge": "Aren't the results above relevant? Continue chatting with me below",
    "chat.experimentalEngineActive": "Experimental engine",
    "chat.limit.body": "To ensure KAI gives you accurate answers, conversations are limited to 50 messages.",
    "chat.limit.button": "Start a new conversation",
    "chat.limit.heading": "Conversation limit reached",
    "chat.multi_stream.capacity_message": "Three calls are already in progress. Please wait until one has finished.",
    "chat.multi_stream.capacity_title": "Too many active conversations",
    "common.askQuestion": "Ask a question",
    "common.cancel": "Cancel",
    "common.closeSidebar": "Close sidebar",
    "common.collapseSidebar": "Close side panel",
    "common.copied": "Copied",
    "common.copy": "Copy",
    "common.defaultThreadTitle": "New thread",
    "common.delete": "Delete",
    "common.disclaimer": "Answers from KAI may contain errors.",
    "common.editMessage": "Edit message",
    "common.expandSidebar": "Open side panel",
    "common.getStarted": "Ask a question to get started!",
    "common.goBack": "Go back",
    "common.loadingTranslations": "Loading translations...",
    "common.malerAndChecklists": "Templates and checklists",
    "common.newChat": "New chat",
    "common.noResults": "No search results",
    "common.openSidebar": "Open sidebar",
    "common.otherContentFromDIB": "Other content from dib",
    "common.recentChats": "Recent chats",
    "common.recentSearches": "Last visited in dib",
    "common.recentThreads": "Latest threads",
    "common.regenerate": "Regenerate response",
    "common.rename": "Rename",
    "common.save": "Save",
    "common.search": "Search",
    "common.searchBox": "Ask <strong>KAI<\/strong> or search for content",
    "common.seeAll": "See all",
    "common.send": "Send",
    "common.share": "Share",
    "common.showAll": "Show all ({{count}})",
    "common.showLess": "Show less",
    "common.suggestions": "Suggestions",
    "common.thinking": "Thinking... AI responses are not always flawless. Remember to check the sources from dib!",
    "common.tryAgain": "Try again",
    "common.visibleForAdmins": "Visible for admins",
    "common.yesterday": "Yesterday",
    "content.comment": "Comment",
    "content.lawRulesMirror": "Regulation mirror",
    "content.relatedSources": "Related sources",
    "content.tags": "Keywords",
    "content.translation": "Translation",
    "contextSidebar.BetaDisclaimer": "The sidebar is under development. We are continuously working to retrieve good search results from dib.",
    "contextSidebar.OtherHeading": "Other content from dib",
    "contextSidebar.ThreadExplanation": "Chat description (AI-generated)",
    "contextSidebar.ToolsHeading": "Tools from dib",
    "contextSidebar.closeContextSidebar": "Close context sidebar",
    "contextSidebar.error": "Failed to load content",
    "contextSidebar.noRelatedContent": "No related topics or sources found in dib",
    "contextSidebar.noRelatedTemplates": "No related templates or checklists were found in dib",
    "contextSidebar.openContextSidebar": "Open sidebar",
    "date.last30Days": "Last 30 days",
    "date.lastWeek": "Last week",
    "date.previously": "Previously",
    "date.today": "Today",
    "debug.addSuggestion": "Add suggestion",
    "error.contentFilter.body": "The question was blocked by the content filter. Edit your message above and try using different wording.",
    "error.contentFilter.title": "Content Filtering",
    "error.contextLength.body": "The chat has grown too long.",
    "error.contextLength.title": "Chat too long",
    "error.filteredContent.body": "The response was filtered due to the prompt triggering our content management policy. Please modify your prompt and retry.",
    "error.interrupted.body": "The previous response was not completed. Try asking the question again to get a new response.",
    "error.interrupted.title": "The response was interrupted",
    "error.rateLimit.body": "You have reached the limit for the number of requests. Wait a few minutes and try again. If the problem persists, contact support.",
    "error.rateLimit.title": "Too many requests",
    "error.unknown.body": "An unknown error occurred while generating the response.",
    "error.unknown.title": "Unknown error",
    "file.download": "Download {{file}}",
    "file.downloadNotForDemo": "Downloading of files is not available for demo users",
    "forbidden.description": "Sorry, you do not have permission to access this application. Please contact us if you believe this is an error.",
    "forbidden.title": "Access denied",
    "input.placeholder.splash": "What do you need help with?",
    "input.placeholder.thread": "Ask a follow-up question",
    "menu.item.desc.deep": "Analyzes and reasons more",
    "menu.item.desc.fast": "KAI gives you simple, quick answers",
    "menu.item.disabledtooltip.deep": "This functionality is not available to you.",
    "menu.item.time.deep": "~20 sec",
    "menu.item.time.fast": "~10 sec",
    "menu.item.title.deep": "KAI+",
    "menu.item.title.fast": "Quick response",
    "name.Dflow": "Dflow",
    "prompt.heading.welcome": "What can I help with?",
    "rag.state.answering": "Answering",
    "rag.state.finished": "Thought for {n} seconds",
    "rag.state.finishedNoTime": "Summary",
    "rag.state.idle": "Thinking",
    "rag.state.reading": "Reading content",
    "rag.state.searching": "Searching sources",
    "rag.state.summarizing": "Putting together relevant sources",
    "rating.addRating": "Give feedback",
    "rating.comment.placeholder": "Comment",
    "rating.editRating": "Edit feedback",
    "rating.modal.button": "Submit feedback",
    "rating.modal.cancel": "Skip",
    "rating.modal.category.0": "The answer contains errors",
    "rating.modal.category.1": "KAI did not follow my instructions",
    "rating.modal.category.2": "I didn't like the structure of the answer",
    "rating.modal.category.3": "KAI is using wrong sources from dib",
    "rating.modal.category.4": "Other feedback",
    "rating.modal.category.5": "Outdated information",
    "rating.modal.description": "Please choose a category below. Thank you for helping us improve KAI.",
    "rating.modal.elaborate": "Please elaborate...",
    "rating.modal.title": "Thank you for your feedback",
    "rating.response.isHelpful": "Rate response as helpful",
    "rating.response.isNotHelpful": "Rate response as not helpful",
    "rating.submit": "Submit",
    "rating.text": "Leave a comment",
    "references.consideredSources.title": "In addition, KAI searched through these sources:",
    "references.consideredSources.tooltip": "Show other considered sources",
    "references.relatedTools.title": "Suggested tools",
    "references.title": "The answer is based on these sources from DIB",
    "reflections.button.text": "Reflections",
    "reflections.button.text.loading": "Analyzing the question",
    "rename.modal.label": "New name",
    "rename.modal.title": "Rename thread",
    "sessionExpired.description": "Your session has ended, and we were unable to restart it automatically. Please try logging in again. If this continues, please contact support.",
    "sessionExpired.signOut": "Log out",
    "sessionExpired.title": "The session has expired",
    "settings.accountDetails": "Account details",
    "settings.chatEngine": "Chat engine",
    "settings.field.chatEngine.experimental": "Experimental",
    "settings.field.chatEngine.standard": "Standard",
    "settings.field.company.description": "Your company",
    "settings.field.company.title": "Company",
    "settings.field.email.description": "Your email",
    "settings.field.email.title": "Email",
    "settings.field.name.description": "Your name",
    "settings.field.name.title": "Name",
    "settings.field.response.deep": "KAI+",
    "settings.field.response.fast": "Quick",
    "settings.field.sidebarPosition.left": "Left",
    "settings.field.sidebarPosition.right": "Right",
    "settings.language": "Language",
    "settings.logout": "Sign out",
    "settings.preferences": "Settings",
    "settings.responseType": "Preselected answer type",
    "settings.showInternalFeatures": "Show admin functionality",
    "settings.sidebarPosition": "Context sidebar position",
    "settings.title": "Settings",
    "suggestionQuestion.1": "How much can I spend on each employee for the Christmas party?",
    "suggestionQuestion.2": "Rules for free phone?",
    "table.close": "Close",
    "table.expand": "Expand",
    "table.fullscreenTitle": "Close full screen with the cross at the far right, or press the <span>Esc<\/span> key.",
    "table.openFullscreen": "Open table in full screen",
    "thread.postsearch.filters.button": "Filter",
    "thread.postsearch.filters.otherSources": "Sources",
    "thread.postsearch.filters.tools": "Tools",
    "thread.postsearch.note": "<strong>Is the search not returning the results you expected?<strong><\\br> We are constantly working to make the results from DIB more relevant",
    "thread.postsearch.resultsFor": "Search results for",
    "thread.tabs.answer": "Answer from KAI",
    "thread.tabs.answerReady": "Answer ready",
    "thread.tabs.search": "Results in DIB",
    "topicSidebar.OtherHeading": "Other content",
    "topicSidebar.ToolsHeading": "Tools",
    "userinput.button.text.deep": "KAI+",
    "userinput.button.text.fast": "Quick",
    "userinput.placeholder": "Ask KAI",
    "word.Expand": "Expand"
}